/**
 * tdesign v0.21.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { getAttach } from './dom.mjs';
import '../_chunks/dep-a48de419.mjs';
import '../_chunks/dep-2684fd15.mjs';
import '../_chunks/dep-3ca5fb38.mjs';
import '../_chunks/dep-7071345f.mjs';
import '../_chunks/dep-3d4aad09.mjs';
import '../_chunks/dep-c27b1c14.mjs';
import './easing.mjs';

var TransferDom = {
  mounted: function mounted(el, binding) {
    if (!binding.value) return;
    var parentNode = getAttach(binding.value);
    parentNode === null || parentNode === void 0 ? void 0 : parentNode.appendChild(el);
  }
};

export { TransferDom as default };
//# sourceMappingURL=transfer-dom.mjs.map
